import { memo, useEffect, useMemo, useState } from "react"
import Money from "../../../../helpers/utils/money/money";
import Button from "../../../bootstrap/Button";
import FormGroup from "../../../bootstrap/forms/FormGroup";
import Input from "../../../bootstrap/forms/Input";
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../../../bootstrap/Modal";
import { getMenuProductId, isMenuProductActive } from "../../../../helpers/utils/menuProductStatus";

function ProductItem({product, active, onToggleProductStatus}) {
  const canToggleStatus = !!onToggleProductStatus;

  return(
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <img
          src={product.image_url}
          alt='Imagem'
          width={40}
          height={40}
        />
      </div>
      <div className={canToggleStatus ? 'col-md-7' : 'col-md-9'}>
        <FormGroup>
          <Input value={product.name} disabled readOnly />
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <FormGroup>
          <Input
            value={Money.centsToCoin(product.price).toFixed(2)}
            readOnly
          />
        </FormGroup>
      </div>
      {canToggleStatus && (
        <div className='col-md-2'>
          <Button
            isLink
            color={active ? 'success' : 'danger'}
            icon='Circle'
            onClick={() => onToggleProductStatus(product.id)}
            className='text-nowrap'
          >
            {active ? 'Ativo' : 'Inativo'}
          </Button>
        </div>
      )}
      {/* <div className='col-md-2'>
        <FormGroup>
          <Input
            value={Money.centsToCoin(product.discount).toFixed(2)}
            readOnly
          />
        </FormGroup>
      </div> */}
    </div>
  );
}

const ProductElement = memo(ProductItem);

function ListSubCategoryItemsModal({ open, onClose, products, category, productStatus, onToggleProductStatus }) {

  const [productsRender, setproductsRender] = useState([])
  const [productSearch, setProductSearch] = useState('')

  useEffect(() => {
    if(category) {
      const productsInCategory = category.products || [];

      const productsRender = [];
      productsInCategory.forEach(product => {
        const productId = getMenuProductId(product);
        const pFind = products.find(p => p.id === productId);
        if(pFind) {
          productsRender.push({
            id: pFind.id,
            name: pFind.name,
            image_url: pFind.image_url,
            price: pFind.price,
            // discount: pFind.discount,
          })
        }
      })

      setproductsRender(productsRender)
    }
  },[products, category])

  useEffect(() => {
    setProductSearch('');
  }, [category?.id])

  const Header = (
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <p>Imagem</p>
      </div>
      <div className={onToggleProductStatus ? 'col-md-7' : 'col-md-9'}>
        <p>Nome</p>
      </div>
      <div className='col-md-2'>
        <p>Preço</p>
      </div>
      {onToggleProductStatus && (
        <div className='col-md-2'>
          <p>Status no cardápio</p>
        </div>
      )}
      {/* <div className='col-md-2'>
        <p>Desconto</p>
      </div> */}
    </div>
  )

  const filteredProducts = useMemo(() => {
    const search = productSearch.trim().toLowerCase();
    if (!search) return productsRender;

    return productsRender.filter((product) =>
      product.name?.toLowerCase().includes(search)
    );
  }, [productsRender, productSearch])

  return(
    <Modal
      id={'modal-category-items'}
      titleId={'Items da Sub-categoria'}
      isOpen={open}
      setIsOpen={onClose}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl' 
      isAnimation={true}
    >
      <ModalHeader setIsOpen={onClose}>
        <ModalTitle id="register-category">{category?.name}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className='row g-4 py-2'>
          <FormGroup className='col-md-12'>
            <Input
              value={productSearch}
              onChange={(event) => setProductSearch(event.target.value)}
              placeholder='Buscar produto'
            />
          </FormGroup>
        </div>

        { Header }

        {filteredProducts.map((product, index) => (
          <ProductElement
            key={'lpmInSubCat' + index}
            product={product}
            active={isMenuProductActive(productStatus, product.id)}
            onToggleProductStatus={onToggleProductStatus}
          />
        ))}

        {filteredProducts.length === 0 && (
          <div className='text-center text-muted py-3'>
            Nenhum produto encontrado
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
          <Button
            color="danger"
            icon="cancel"
            rounded={1}
            onClick={onClose}
            shadow="sm"
            hoverShadow="sm"
            size="sm"
          >
            Fechar
          </Button>
      </div>
      </ModalBody>
    </Modal>
  );
}

export default memo(ListSubCategoryItemsModal);
